import Vue from 'vue'
import Router from 'vue-router'
import { TokenService } from '@/services/storage.service'

Vue.use(Router)

const routerOptions = [
	{ path: '/', component: 'Landing', meta: { public: true } },
	{ path: '/signin', component: 'Signin', meta: { public: true } },
	{ path: '/membership', component: 'Membership' },
	{ path: '/files', component: 'Files' },
	{ path: '/galleries/:userID', component: 'Galleries', meta: { public: true } },
	{ path: '/lightbox/:galleryOrPhotoshoot/:photoshootID/:initialPhotoIndex', component: 'Lightbox', meta: { public: true } },
	{ path: '/photoshoots', component: 'PhotoShoots', meta: { public: true } },
	{ path: '/photoshoot/:id', name: 'photoshoot', component: 'PhotoShoots', meta: { public: true } },
	{ path: '/newsletters', component: 'Newsletters', meta: { public: true } },
	{ path: '/membershare', component: 'MemberShare' },
	{ path: '/newslettershare/:newsletterID', component: 'NewsletterShare' },
	{ path: '/calendar', component: 'Calendar', meta: { public: true } },
	{ path: '/info/:id', name: 'info', component: 'Landing', meta: { public: true } },
	{ path: '/meeting/:id', name: 'meeting', component: 'Landing', meta: { public: true } },
	{ path: '/sitemap', component: 'SiteMap', meta: { public: true } },
	{ path: '/vote', component: 'Vote', meta: { public: true } },
	{ path: '/resources_membershare', component: 'Resources_MemberShare', meta: { public: true } },
	{ path: '/vote_admin', component: 'VoteAdmin' },
	// { path: '/dynamic', name: 'dynamic', component: 'DynamicComponents', meta: {public: false} }
]

const routes = routerOptions.map(route => {
	return {
		...route,
		component: () => import(`@/components/${route.component}.vue`)
	}
})

const router = new Router({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes
})

router.beforeEach((to, from, next) => {
	const isPublic = to.matched.some(record => record.meta.public)
	const loggedIn = !!TokenService.getToken()
	// const loggedIn = store.state.loggedIn
	if (!isPublic && !loggedIn) {
		return next({
			path: '/signin',
			query: { redirect: to.fullPath }  // Store the full path to redirect the user to after login
		})
	}

	next()
})

export default router
